import renderApp from './renderApp';

renderApp('react-root');
